import * as React from 'react';
import BrandCategoryForm from "../../components/Brands/BrandCategoryForm/BrandCategoryForm";
var BrandCategory = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u043C\u0430\u0440\u043A\u043E\u0432\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(BrandCategoryForm, null))))));
};
export default BrandCategory;



//////////////////
// WEBPACK FOOTER
// ./src/views/BrandCategories/BrandCategory.tsx
// module id = 530
// module chunks = 0